import { Component, OnInit,inject, DestroyRef } from '@angular/core';
import { SolutionsService } from 'src/app/services/api/solutions.service';
import { LineOfBusiness } from 'src/app/models/line-of-business';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-our-services',
    templateUrl: './our-services.component.html',
    styleUrls: ['./our-services.component.scss'],
    standalone: false
})
export class OurServicesComponent implements OnInit {

  lineOfBusinesses: LineOfBusiness[];
  private destroyRef = inject(DestroyRef);

  constructor(private solutionsService: SolutionsService) {
  }

  ngOnInit(): void {
    this.solutionsService.getLineOfBusinesses()
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(lineOfBusinesses => {
      this.lineOfBusinesses = lineOfBusinesses;
      this.lineOfBusinesses.sort(this.sortLobByName);
    });
  }

  private sortLobByName(firstLob: LineOfBusiness, secondLob: LineOfBusiness): number {
    const firstLobName = firstLob.displayName.toUpperCase();
    const secondLobName = secondLob.displayName.toUpperCase();
    if (firstLobName > secondLobName) {
      return 1;
    }
    if (secondLobName > firstLobName) {
      return -1;
    }
  }

}
